module.exports = __webpack_public_path__ + "img/int-done.f212f073.svg";